import styled from 'styled-components';

const label = styled.span`
  margin-right: 0.5rem;
`;

const Text = {
  Label: label,
};

export default Text;
